<template>
	<div ref="container">
		<slot></slot>

		<b-modal :id="`confirmModal-${objectId}`" headerClass="indigo">
			<template v-slot:modal-title>
				<h3 class="modal-title full-bar-title">{{ verbs.upper }} {{ typeName }}</h3>
			</template>
			<div class="p-2">
				<div class="form-group pl-2 pr-3">
					<h3>
						<slot name="confirmMessage">
							Are you sure you want to {{ verbs.lower }} the {{ typeName }}
							<span class="text-danger _600">"{{ objectName }}"</span>?
						</slot>
					</h3>
				</div>
			</div>
			<template v-slot:modal-footer="{ _, cancel }">
				<button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
				<button type="button" class="btn btn-danger" @click="del">
					{{ verbs.upper }}
				</button>
			</template>
		</b-modal>

		<b-modal :id="`cantDeleteModal-${objectId}`" headerClass="indigo">
			<template v-slot:modal-title>
				<h3 class="modal-title full-bar-title">Cannnot {{ verbs.upper }}</h3>
			</template>
			<div class="p-2">
				<div class="form-group pl-2 pr-3">
					<slot name="cantDeleteMessage">
						<h3>
							The {{ typeName }} <span class="text-danger _600">"{{ objectName }}"</span> cannot be
							{{ verbs.lowerPast }}
						</h3>
					</slot>
				</div>
			</div>
			<template v-slot:modal-footer="{ ok }">
				<button type="button" class="btn btn-primary" @click="ok">
					Okay
				</button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import Notie from "@/services/NotieService";

export default {
	name: "ConfirmDelete",

	props: ["typeName", "objectName", "objectId", "canDelete", "delete", "cleanup", "removeNotDelete"],

	data() {
		return {
			verbs: {
				lower: "delete",
				upper: "Delete",
				lowerPast: "deleted",
				upperPast: "Deleted",
			},
		};
	},

	mounted() {
		if (this.removeNotDelete) {
			this.verbs = {
				lower: "remove",
				upper: "Remove",
				lowerPast: "removed",
				upperPast: "Removed",
			};
		}
		this.$refs.container.childNodes[0].addEventListener("click", this.checkCanDelete);
	},

	methods: {
		checkCanDelete() {
			return this.canDelete(this.objectId)
				.then((r) => {
					console.log(r);
					if (r.data.can_delete) {
						this.openConfirmModal();
					} else {
						this.openCantDeleteModal();
					}
				})
				.catch((e) => {
					console.log({ error: e });
					Notie.error("Server error", e);
				});
		},

		openConfirmModal() {
			this.$bvModal.show(`confirmModal-${this.objectId}`);
		},

		openCantDeleteModal() {
			this.$bvModal.show(`cantDeleteModal-${this.objectId}`);
		},

		del() {
			return this.delete(this.objectId)
				.then((r) => {
					console.log(r);
					this.$bvModal.hide(`confirmModal-${this.objectId}`);
					Notie.success(`${this.verbs.upperPast} ${this.typeName} "${this.objectName}"`);
					if (this.cleanup) {
						this.cleanup();
					}
				})
				.catch((e) => {
					console.log(e);
					Notie.error(`Failed to ${this.verbs.lower} ${this.typeName}`, e);
				});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
	padding-top: 13.5px;
	padding-right: 8px;
	padding-bottom: 50px;
	cursor: pointer;
}

.line {
	position: relative;
	border-bottom: 3px solid rgb(200, 200, 200);
}

.tick {
	position: absolute;
	top: -13.5px;
	height: 30px;
	border-left: 3px solid rgb(200, 200, 200);
	pointer-events: none;
}

.tick-text {
	position: absolute;
	top: 34px;
	width: 50px;
	left: -26px;
	text-align: center;
	font-size: 18px;
}

.label-table {
	width: 100%;
	table-layout: fixed;
}

.label {
	user-select: none;
	-webkit-user-select: none;
	pointer-events: none;
	font-size: 18px;
	font-weight: 600;
	padding: 0.5rem;
	text-align: center;
}

.dot {
	position: absolute;
	top: -7px;
	border-radius: 50%;
	width: 16px;
	height: 16px;
	background-color: rgb(200, 200, 200);
	pointer-events: none;
}

.number-line-end {
	position: absolute;
	right: -13px;
	top: -7px;
	height: 17px;
	width: 12px;
	border-left: 12px solid rgb(200, 200, 200);
	border-top: 8px solid transparent;
	border-bottom: 8px solid transparent;
	pointer-events: none;
}
</style>
